import {Component, Input, OnChanges, OnInit, SimpleChanges, SimpleChange} from '@angular/core';
import {OptionService} from "../option/option.service";
import {TranslateService} from "@ngx-translate/core";
import {Donation} from "../donation/donation";
import {HttpClient} from "@angular/common/http";

@Component({
    selector: 'project-donators',
    templateUrl: './output.project-donators.component.html',
    providers: []
})
export class ProjectDonatorsComponent implements OnInit, OnChanges {
    /**
     * the current step
     */
    @Input() step: string;

    /**
     * The current donation
     */
    @Input() donation: Donation;

    /**
     * Holds the type of the project
     */
    @Input() projectType: string = null;

    /**
     * Holds all donations that should be shown
     */
    donations: any = [];

    /**
     * text that is used as name for anonymous donators
     */
    textAnonynous: string = null;

    /**
     * current currency
     */
    currency: string = null;

    /**
     * number of items to be visble on the start and every "show more" click
     */
    itemsPerPage: number = 10;

    /**
     * currently visible items
     */
    visibleItems: number = 10;

    /**
     * Number of items overall
     */
    itemOverallCount: number = 0;

    /**
     * constructor
     * @param optionService
     * @param translationService
     * @param http
     */
    constructor(private optionService: OptionService, private translationService: TranslateService, private http: HttpClient) {}

    /**
     * Called when the component is initialized
     */
    public ngOnInit(): void {
        // get donations but only show the first X items
        this.donations = this.optionService.getProjectDonations();
        this.itemOverallCount = this.donations.length;
        this.sliceDonations();

        // get an update of the donation amount
        let updateUrl = this.optionService.getProjectTargetUpdateUrl();
        if(updateUrl) {
            this.http.get(updateUrl).subscribe(data => {
                if(data && data.hasOwnProperty("donations")) {
                    this.optionService.setProjectDonations(data["donations"]);
                    this.itemOverallCount = data["donations"].length;
                    this.donations = this.optionService.getProjectDonations().slice(0, this.itemsPerPage);
                }
            });
        }

        this.currency = this.donation.currencySymbol;

        let that = this;
        this.translationService.get('projectdonators.from.anonymous').subscribe(function(text) {
           that.textAnonynous = text;
        });
    }

    /**
     * Slice donations
     *
     * @param {number} more optional, show X items more
     */
    public sliceDonations(more: number = null): void {
        if(more > 0) {
            this.visibleItems += more;
        }

        this.donations = this.optionService.getProjectDonations().slice(0, this.visibleItems);
    }

    /**
     * check for changes in the step to see if we got a successful donation
     * @param changes
     */
    public ngOnChanges(changes: SimpleChanges): void {
        const step: SimpleChange = changes.step;
        if(step.firstChange === false && step.currentValue === "thankyou" && this.donation.transactionGuid) {
            // we've got a successful donation. put this to the list of donators
            this.donations.unshift({
                amount: this.donation.amount,
                data: this.donation.donatorData,
                timediff: 0,
                timediffUnit: 'minutes'
            });
        }
    }

    /**
     * Returns the text for the unit of the timediff
     * @param timeDiff
     */
    getTimeTimeDiffText(timeDiff: string) {
        return this.translationService.instant('projectdonators.time.' + timeDiff);
    }
}
